var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["CorbadoApp"]: () => (__WEBPACK_EXTERNAL_MODULE__corbado_web_core_ce83ee2f__.CorbadoApp) });